import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../services/api';
import { queryKeys } from '../../lib/queryKeys';
import type { User } from '../../types/api';

export function useUser(supabaseId: string | undefined) {
  const { data, isLoading, error, refetch } = useQuery<User>({
    queryKey: queryKeys.user(supabaseId!),
    queryFn: () => apiClient.getUser({ supabase_id: supabaseId! }),
    enabled: !!supabaseId,
    staleTime: 30_000,
  });

  return {
    user: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
    refetch,
  };
}
